import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ResUpdateRoomInventory } from "../../Services/Service";

// thunk (single API call)
export const updateRoomInventory = createAsyncThunk(
    "inventory/updateRoomInventory",
    async ({ PID, Date, Count, RoomTypeCode }, { rejectWithValue }) => {
        try {
            const res = await ResUpdateRoomInventory(
                PID,
                Date,
                Count,
                RoomTypeCode
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Error updating inventory");
        }
    }
);

const reseinventorySlice = createSlice({
    name: "inventory",
    initialState: {
        loading: false,
        success: false,
        error: null,
    },
    reducers: {
        resetInventoryState: (state) => {
            state.loading = false;
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateRoomInventory.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateRoomInventory.fulfilled, (state) => {
                state.loading = false;
                state.success = true;
            })
            .addCase(updateRoomInventory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetInventoryState } = reseinventorySlice.actions;
export default reseinventorySlice.reducer;